import i18n from '../../../i18n';
import { useGlobal } from '../GlobalContext/GlobalContext';
import useSocketSubscription from '../../../Hooks/useSocketSubscription';
import useSocketEvent from '../../../Hooks/useSocketEvent';
import { Resource, Action } from '../../../Constants/socket';

const UserLanguageSync = () => {
  const { user, changeUser } = useGlobal();
  const userId = user?.id;

  // Subscribe to the current user's resource over socket
  useSocketSubscription(Resource.USER, userId ? [userId] : null);

  // Handle USER:UPDATE events (e.g., when language is changed from another client)
  useSocketEvent(Resource.USER, Action.UPDATE, (updatedUser) => {
    if (!updatedUser || !updatedUser.id || !userId || updatedUser.id !== userId) return;

    // Merge latest user data into global context (also updates localStorage via GlobalContext)
    changeUser((prevUser) => ({
      ...(prevUser || {}),
      ...updatedUser,
    }));

    const newLanguage = updatedUser.language;
    if (newLanguage && newLanguage !== i18n.language) {
      i18n.changeLanguage(newLanguage);
    }
  });

  return null;
};

export default UserLanguageSync;

